<template>
  <div class="contact-block border p-3 mt-3 mt-md-4">
    <div class="color-text-dark font-size-xxs font-weight-bold mb-2">
      {{ i18n.contactBlockTitle }}
    </div>

    <div class="font-size-xxs">
      {{ i18n.contactBlockText }}
    </div>

    <div class="d-flex align-items-center mt-3">
      <div class="d-flex flex-column align-items-center flex-shrink-0 mr-3">
        <div class="contact-block__image position-relative overflow-hidden">
          <img
            :src="image"
            alt=""
            class="img-fit absolute-center"
            loading="lazy"
          >
        </div>

        <div class="contact-block__name">
          {{ i18n.contactBlockName }}
        </div>
      </div>

      <div class="d-flex flex-column">
        <a :href="`tel:${settings.phoneFormatted}`" class="contact-option mb-2">
          <span class="btn btn--secondary btn--icon-only btn--rounded btn--sm">
            <Icon name="phone" />
          </span>

          <span>
            {{ settings.phone }}
          </span>
        </a>

        <a :href="`mailto:${settings.email}`" class="contact-option">
          <span class="btn btn--secondary btn--icon-only btn--rounded btn--sm">
            <Icon name="envelope" />
          </span>

          <span>
            {{ settings.email }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/cart/components/Icon.vue';

export default {
  components: {
    Icon,
  },

  props: {
    image: {
      type: String,
      required: false,
      default: '/front_assets/img/placeholders/560x315.png',
    },
  },
};
</script>
